const aws_secrets = {
  Auth: {
    identityPoolId: 'ap-southeast-2:a36ad7b8-ec41-4778-9134-040c539aef8b',
    region: 'ap-southeast-2', 
    userPoolId: 'ap-southeast-2_jcUUatWTs',
    userPoolWebClientId: '6fog74efovcl3mvsn5bt97fg2h',
    mandatorySignIn: true
  }
}

export default aws_secrets;


// WEBPACK FOOTER //
// ./src/aws-secrets.js